<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" @click="toggleSelectAll" class="btn btn-fill btn-primary mr-3">
          Alle auswählen
        </button>

        <button class="btn btn-success" @click="restoreSelectedWarehouses">
          <i class="fa fa-recycle"></i>
          Ausgewählte Läger wiederherstellen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <p v-if="warehouses.length === 0">Keine gelöschten Läger vorhanden.</p>
          <transition name="el-fade-in-linear">
            <table class="table table-striped table-bordered" v-if="warehouses.length">
              <thead>
                <tr>
                  <th width="10px">&nbsp;</th>
                  <th>Kurzname</th>
                  <th>Name</th>
                  <th>Standort</th>
                  <th>Straße</th>
                  <th>PLZ</th>
                  <th>Ort</th>
                </tr>
              </thead>
              <tr v-for="warehouse in warehouses" :key="warehouse.id">
                <td class="handle"> <input type="checkbox" :value="warehouse.id" v-model="selectedWarehouses"></td>
                <td v-text="warehouse.short_name"></td>
                <td v-text="warehouse.name"></td>
                <td v-text="warehouse.location ? warehouse.location.name : ''"></td>
                <td v-text="warehouse.street"></td>
                <td v-text="warehouse.zip"></td>
                <td v-text="warehouse.place"></td>
              </tr>
            </table>
          </transition>
        </div>
      </div>
       <a href="/warehouses">
         <button type="submit" class="btn btn-fill btn-info mr-3">
          Zurück
        </button>
      </a>
    </card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      warehouses: [],
      locations: [],
      selectedWarehouses: [],
      selectAll: false,
    }
  },
  methods: {
    getData(query) {
      this.$http.get(`/soft_deleted/warehouses`).then(({ data }) => {
        this.warehouses = data
      })
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      if (this.selectAll) {
        this.selectedWarehouses = this.warehouses.map(warehouse => warehouse.id);
      } else {
        this.selectedWarehouses = [];
      }
    },
    restoreSelectedWarehouses() {
      if (this.selectedWarehouses.length) {
        const selectedWarehouses = this.warehouses.filter(warehouse => this.selectedWarehouses.includes(warehouse.id));
        const selectedWarehousesIds = selectedWarehouses.map(warehouse => warehouse.id)
        const selectedWarehousesNames = selectedWarehouses.map(warehouse => warehouse.name)
        this.$http.post(`/soft_deleted/warehouses/restore`, { ids: selectedWarehousesIds }).then(() => {
          this.$notify({
            message: `Läger: ${selectedWarehousesNames} erfolgreich wiederhergestellt.`,
            type: 'success'
          });
          this.getData();
          setTimeout(() => {
            this.$router.push('/warehouses');
          }, 2000);
        })
      }
    },
  },
  created() {
    this.getData()
  }
}
</script>
